import { Reveal } from "./Reveal";
import { STEPS } from "../../lib/content";

export const HowItWorks = () => (
  <section id="how" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal className="lg:sticky lg:top-32">
            <p className="overline mb-4">How it works</p>
            <h2 className="font-heading text-3xl font-medium tracking-tight text-[#0A0C14] sm:text-4xl lg:text-5xl">
              A checkout your customers won't abandon.
            </h2>
            <p className="mt-5 text-base text-slate-600 lg:text-lg">
              Mobile-first, sub-1.5-second load, works on poor connections. Every edge case — underpayment, wrong chain, congestion — documented and handled.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <ol className="relative border-l border-slate-200 pl-8 sm:pl-10">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.08}>
                <li data-testid={`how-step-${s.n}`} className="group relative pb-12 last:pb-0">
                  <span className="font-mono absolute -left-[2.8rem] flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-sm text-slate-500 transition-colors duration-300 group-hover:border-[#3B5FE8] group-hover:bg-[#3B5FE8] group-hover:text-white sm:-left-[3.35rem] sm:h-9 sm:w-9">
                    {s.n}
                  </span>
                  <h3 className="font-heading text-xl font-medium text-[#0A0C14] lg:text-2xl">{s.title}</h3>
                  <p className="mt-2 max-w-lg text-sm leading-relaxed text-slate-600 lg:text-base">{s.desc}</p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);
